import React from 'react'
import ToggleSwitch from './ToggleSwitch'

class bezirk extends React.Component {
  constructor(props) {
    super(props);

    // states for map bezirk
    this.state = {
      master:  [
      {
          id: 'master',
          name: "Master",
          checked: true
        }
      ],
      bezirk: [
         {
          id: 'all',
          name: "Alle",
          checked: true
        },
        {
          id: 'mitte',
          name: "Mitte",
          checked: true
        },
        {
          id: 'kreuzberg',
          name: "Friedrichshain-Kreuzberg",
          checked: true
        },
        {
          id: 'pankow',
          name: "Pankow",
          checked: true
        },
        {
          id: 'charlottenburg',
          name: "Charlottenburg-Wilmersdorf",
          checked: true
        }
        ,
        {
          id: 'spandau',
          name: "Spandau",
          checked: true
        },
        {
          id: 'stegliz',
          name: "Steglitz-Zehlendorf",
          checked: true
        },
        {
          id: 'tempelhof',
          name: "Tempelhof-Schöneberg",
          checked: true
        },
        {
          id: 'neukolln',
          name: "Neukölln",
          checked: true
        },
        {
          id: 'treptow',
          name: "Treptow-Köpenick",
          checked: true
        },
        {
          id: 'marzahn',
          name: "Marzahn-Hellersdorf",
          checked: true
        },
        {
          id: 'lichtenberg',
          name: "Lichtenberg",
          checked: true
        },
        {
          id: 'reinickendorf',
          name: "Reinickendorf",
          checked: true
        }
        ]
    };


    // send bezirk to map data
    
    this.props.setBezirk(this.state);

  }



  onToggleLayerStatus = (toggledLayer) => {
       
    const bezirk  = this.state.bezirk;
    const master = this.state.master;

    const nextMasterState = master.map(master => {
      
       if (toggledLayer.layerId !== 'master') return master;
       else {return {
             ...master,
            checked: toggledLayer.checked
            };
        }    
  
       });
    

    const nextLayerState = bezirk.map(bezirk => {
     
      
      if (toggledLayer.layerId === 'all'){

         // onToggleLayerStatus(bezirk)
          return {
          ...bezirk,
          checked: toggledLayer.checked
        };

      }else{

        if (toggledLayer.layerId !== bezirk.id) return bezirk;
        
        else {
        return {
          ...bezirk,
          checked: toggledLayer.checked
        };
      }
      }

      
    });

    
    // update bezirk states and map data
    this.setState(prevState => ({ bezirk: nextLayerState , master: nextMasterState}), () => {
      this.props.setBezirk(this.state);
      }
    );



  }

  render() {
    
    const bezirk = this.state.bezirk;
    const master = this.state.master;

    return (
      <div>
        <h4>Bezirk</h4>
                 
        {bezirk.map(bezirk => (

        <ToggleSwitch
          key={bezirk.id}
          name={bezirk.name}
          layerId={bezirk.id}
          checked={bezirk.checked}
          onToggleLayer={this.onToggleLayerStatus}
        />
      ))}

      </div>
    );
  }
}

export default bezirk
